const PII_KEYS = new Set([
  'apartment',
  'email',
  'phone',
  'phoneNumber',
  'ssn',
  'socialSecurityNumber',
  'street',
  'zipCode',
  'postalCode',
  'firstName',
  'lastName',
  'fullName',
  'name',
])

type JsonPrimitive = string | number | boolean | null
type JsonValue = JsonPrimitive | JsonObject | JsonArray
type JsonArray = JsonValue[]
interface JsonObject {
  [key: string]: JsonValue
}

/**
 * Recursively removes PII keys from an object.
 * @param obj - The object to filter.
 * @param customPiiKeys - Optional additional keys to treat as PII.
 */
export function filterPII<T extends JsonObject>(obj: T, customPiiKeys?: Set<string>): Partial<T> {
  const piiKeys = customPiiKeys ? new Set([...PII_KEYS, ...customPiiKeys]) : PII_KEYS
  const filtered: JsonObject = {}

  for (const [key, value] of Object.entries(obj)) {
    if (piiKeys.has(key)) continue

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      filtered[key] = filterPII(value as JsonObject, customPiiKeys) as JsonValue
    } else if (Array.isArray(value)) {
      filtered[key] = value.map(item =>
        item && typeof item === 'object' && !Array.isArray(item)
          ? filterPII(item as JsonObject, customPiiKeys)
          : item
      ) as JsonValue
    } else {
      filtered[key] = value
    }
  }

  return filtered as Partial<T>
}
